<main class="container pt-5" [attr.aria-label]="'content.login2' | translate">

  <div class="row">
    <div class="col-md-12 col-lg-6">
      <div class="d-flex align-items-center h-100">
        <div class="w-50">
          <img alt="" src="../../assets/images/loginPic.png"/> <!-- AODA - decorative image. Ignore. -->
        </div>
        <div class="w-50">
          <h1>{{ 'content.login-header' | translate }}</h1>
          <p class="section-body">{{ 'content.login-body' | translate }}</p>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      @if (showUsernamePasswordForm) {
        <div>
          <div class="d-flex justify-content-center align-items-center h-100">
            <div class="ng-bootstrap-card tu-shadow login-card">
              <div class="col-12" [attr.aria-label]="'content.login-form' | translate" role="region">
                <h1 class="no-underline text-center">{{ 'content.tu-direct' | translate }}</h1>
                <h2 class="no-underline text-center">{{ 'content.login' | translate }}</h2>

                @if (showPasswordForm && loginForm?.value?.username) {
                  <div class="d-flex justify-content-center">
                    <ng-template #userTooltip>
                      {{ 'content.click-to-enter-different-user' | translate:{username:loginForm.value.username} }}
                    </ng-template>
                    <button class="username-badge" (click)="resetLoginForm()" [ngbTooltip]="userTooltip">
                      {{ loginForm.value.username }}
                    </button>
                  </div>
                }

                <p class="pt-3">{{ 'content.log-in-to-tu-direct' | translate }}</p>

                @if (showForwardWarning) {
                  <div>
                    <p>
                      {{ 'content.not-migrated-warning' | translate }}
                      <a [href]="appConfig.legacyForwardUrl">{{ 'content.legacy-tu-direct' | translate }}</a>
                    </p>
                  </div>
                }

                <!-- Guard the form rendering until loginForm exists -->
                @if (loginForm) {
                  @if (showUsernameForm || showPasswordForm) {
                    <div>
                      @if (loginFailed) {
                        <div class="error-box p-2 mb-2" aria-live="assertive" aria-atomic="true">
                          {{ 'content.username-or-password-incorrect' | translate }}
                        </div>
                      }
                      @if (loginAccessFailed) {
                        <div class="error-box p-2 mb-2" aria-live="assertive" aria-atomic="true">
                          {{ 'content.username-or-password-login-access' | translate }}
                        </div>
                      }
                      @if (loginLocked) {
                        <div class="error-box p-2 mb-2" aria-live="assertive" aria-atomic="true"
                             [innerHTML]="'content.username-or-password-locked' | translate">
                        </div>
                      }

                      <form [formGroup]="loginForm"
                            [ngClass]="{'form-submitted': showFormErrors}"
                            (ngSubmit)="submitLogin()">

                        <!-- USERNAME STEP -->
                        @if (showUsernameForm) {
                          <div>
                            <div class="form-group">
                              <label class="visually-hidden" for="username">
                                {{ 'content.user-id' | translate }}:
                              </label>
                              <input #usernameInput
                                     id="username"
                                     class="form-control"
                                     type="text"
                                     autocomplete="on"
                                     formControlName="username"
                                     [placeholder]="'content.user-id' | translate"
                                     (keydown.enter)="$event.preventDefault(); submitUsername()">
                              <app-validation-errors
                                [displayErrors]="showFormErrors"
                                [element]="usernameInput"
                                [errors]="loginForm?.controls?.username?.errors">
                              </app-validation-errors>
                            </div>

                            <div class="form-group d-flex justify-content-end align-items-center">
                              <button class="tu-button primary tu-shadow pt-2"
                                      type="button"
                                      (click)="submitUsername()">
                                {{ 'content.next' | translate }}
                              </button>
                            </div>
                          </div>
                        }

                        <!-- PASSWORD STEP -->
                        @if (showPasswordForm) {
                          <div>
                            <div class="form-group">
                              <label class="visually-hidden" for="password">
                                {{ 'content.password' | translate }}:
                              </label>
                              <input #passwordInput
                                     id="password"
                                     class="form-control"
                                     type="password"
                                     autocomplete="on"
                                     formControlName="password"
                                     [placeholder]="'content.password' | translate">
                              <app-validation-errors
                                [displayErrors]="showFormErrors"
                                [element]="passwordInput"
                                [errors]="loginForm?.controls?.password?.errors">
                              </app-validation-errors>
                            </div>

                            <div class="form-group d-flex justify-content-between align-items-center">
                              <a routerLink="/forgot-password"
                                 [attr.aria-label]="'content.go-to-forgot-password' | translate">
                                {{ 'content.forgot-password' | translate }}
                              </a>
                              <div class="inline-gap-10">
                                <button class="tu-button secondary tu-shadow pt-2"
                                        type="button"
                                        [attr.aria-label]="'content.click-to-enter-different-user' | translate:{username:loginForm.value.username}"
                                        (click)="resetLoginForm()"
                                        (keydown.enter)="$event.preventDefault(); resetLoginForm()">
                                  {{ 'content.back' | translate }}
                                </button>
                                <button class="tu-button primary tu-shadow pt-2" type="submit">
                                  {{ 'content.login' | translate }}
                                </button>
                              </div>
                            </div>
                          </div>
                        }
                      </form>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      }

      @if (showMfaAuthenticate || showMfaAddDevice || showMfaDeviceAdded) {
        <div class="d-flex justify-content-center">
          <div class="ng-bootstrap-card tu-shadow login-card">
            <div [attr.aria-label]="'content.mfa-authentication-form' | translate" role="region">
              @if (showMfaAuthenticate && initialMfaDevice) {
                <app-mfa-authenticate
                  [initialDevice]="initialMfaDevice"
                  [jwtToken]="jwtToken?.token"
                  [userName]="userName"
                  (cancel)="logout()"
                  (newJwtToken)="onMfaCodeSubmitted($event)">
                </app-mfa-authenticate>
              }
            </div>

            @if (showMfaAddDevice || showMfaDeviceAdded) {
              <div [attr.aria-label]="'content.mfa-add-a-device' | translate" role="region">
                @if (showMfaAddDevice) {
                  <div>
                    <h1>{{ 'content.mfa' | translate }}</h1>
                    <p>{{ 'content.required-to-add-mfa' | translate }}</p>
                    <p>{{ 'content.need-to-log-in-again' | translate }}</p>
                    <p>{{ 'content.update-mfa-devices-later' | translate }}</p>
                    @if (userName && !showMfaDeviceAdded) {
                      <app-add-mfa-device class="pt-2"
                                          [userName]="userName"
                                          (added)="onMfaDevicesChanged()">
                      </app-add-mfa-device>
                    }
                  </div>
                }

                <div>
                  @if (showMfaDeviceAdded) {
                    <p>{{ 'content.successfully-added-a-multi-factor-device' | translate }}</p>
                  }
                  <div class="d-flex justify-content-end submit-buttons mt-4">
                    <button class="tu-button tu-shadow"
                            [ngClass]="{'primary': showMfaDeviceAdded, 'secondary': !showMfaDeviceAdded}"
                            (click)="logout()">
                      {{ (showMfaDeviceAdded ? 'content.finish' : 'content.cancel') | translate }}
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</main>
